import { monthQueryParamSchema, yearQueryParamSchema } from '@klopotun/contracts';
import { addMonths } from '@klopotun/domain';
import type { z } from 'zod';
import { MONTH_SEARCH_PARAM, YEAR_SEARCH_PARAM } from '../../../shared/config/index.js';

export type ChosenPeriod = {
  year: number | null;
  month: number | null;
};

export type ShownPeriod = {
  year: number;
  month: number | null;
};

export type ShownMonth = {
  year: number;
  month: number;
};

type NumberParamSchema = z.ZodType<number, string>;

const numberParamOf = (
  params: URLSearchParams,
  name: string,
  schema: NumberParamSchema,
): number | null => {
  const parsed = schema.safeParse(params.get(name) ?? '');

  return parsed.success ? parsed.data : null;
};

export const periodOfSearch = (params: URLSearchParams): ChosenPeriod => ({
  year: numberParamOf(params, YEAR_SEARCH_PARAM, yearQueryParamSchema),
  month: numberParamOf(params, MONTH_SEARCH_PARAM, monthQueryParamSchema),
});

const withParam = (params: URLSearchParams, name: string, value: number | null): void => {
  if (value === null) {
    params.delete(name);

    return;
  }

  params.set(name, String(value));
};

export const withPeriod = (current: URLSearchParams, period: ChosenPeriod): URLSearchParams => {
  const next = new URLSearchParams(current);

  withParam(next, YEAR_SEARCH_PARAM, period.year);
  withParam(next, MONTH_SEARCH_PARAM, period.month);

  return next;
};

export const toChosenPeriod = (shown: ShownPeriod, yearOfToday: number): ChosenPeriod => ({
  year: shown.year === yearOfToday ? null : shown.year,
  month: shown.month,
});

export const shiftMonth = (shown: ShownMonth, months: number): ShownMonth => {
  const shifted = addMonths({ year: shown.year, month: shown.month, day: 1 }, months);

  return { year: shifted.year, month: shifted.month };
};
